import { generateAuthHeader } from "../../commonfunctions/authentication";
import { TransactionType, IGetTransactions, TransactionResponseTypes } from "./types";

export default async function getTransactions(
  transactionType: TransactionType,
  startDate: string,
  endDate: string,
): Promise<IGetTransactions> {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_HALFBACK_ROOT_API}/current_customer/transactions?type=${transactionType}&start_date=${startDate}&end_date=${endDate}`,
      generateAuthHeader(),
    );

    if (res.ok) {
      const data = await res.json();

      if (data.status === "success") {
        return {
          type: TransactionResponseTypes.SUCCESS,
          transactions: data.result.transactions,
        };
      }
      return {
        type: TransactionResponseTypes.FAIL,
        message: data.result.Message,
      };
    }
    throw new Error();
  } catch (error) {
    return {
      type: TransactionResponseTypes.FAIL,
      message: "Failed to load Transactions",
    };
  }
}
